export default {
    filters: {
        nl_numberformat(value){
            if(value != null && value != '') {
                if((""+value).includes(",")) { // is NL format?  (JS number format only contains a decimal dot --> not a thousand separator comma)        
                    value = ((""+value).replace(".", "")).replace(",", "."); // first restore JS number format if needed then return NL format for complete value
                }                 
                return new Intl.NumberFormat('nl-NL', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}).format(value);
            } else {
                return value;
            }
        },
        prefix_euro(value) {
            if (value != '') {
                return "€ " + value;
            }
            else {
                return value;
            }
        },        
    },    
    methods: {
        numericalKeydownNL(e) {

            var allowedalphakeys = [8, 9, 188, 46, 35, 36, 37, 39];
            var allowedctrlkeys = [65, 67, 88, 86];
            var allowednumpadkeys = [35, 36, 37, 39];

            if (!(
                ((e.keyCode >= 48 && e.keyCode <= 57) && !e.shiftKey)
                || (e.keyCode == 189 && !e.shiftKey)
                || (e.keyCode >= 96 && e.keyCode <= 105)
                || allowedalphakeys.includes(e.keyCode)
                || (allowedctrlkeys.includes(e.keyCode) && e.ctrlKey)
                || (allowednumpadkeys.includes(e.keyCode) && e.shiftKey)
            )) {
                e.preventDefault();
            }          
        },
        to_nl_numberformat(value) {
            // decimal seperator must be "," for input value
            // console.log('value', value);
            if(value != null && value != '' && value != '0') {    
                if((""+value).includes(",")) { // is NL format?  (JS number format only contains a decimal dot --> not a thousand separator comma)        
                    value = ((""+value).replace(".", "")).replace(",", "."); // first restore JS number format if needed then return NL format for complete value
                } 
                return new Intl.NumberFormat('nl-NL', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}).format(+value);
            } else {
                return '0';
            }
        },           
    }
}